import React from 'react'
import { Link } from 'react-router-dom'
import Logo from './Logo'
import ArrowMark from './ArrowMark'

const navItems = [
  { k: 'home', l: 'Home', path: '/' },
  { k: 'about', l: 'About', path: '/about' },
  { k: 'services', l: 'Services', path: '/services' },
  { k: 'projects', l: 'Projects', path: '/projects' },
  { k: 'highlights', l: 'Highlights', path: '/highlights' },
  { k: 'clients', l: 'Clients', path: '/clients' },
  { k: 'equipment', l: 'Equipment', path: '/equipment' },
  { k: 'contact', l: 'Contact', path: '/contact' },
]

export default function Footer() {
  return (
    <footer style={{ background: 'var(--dark)', color: '#E6E5DE', marginTop: 120, position: 'relative', overflow: 'hidden' }}>
      {/* large logo watermark */}
      <div style={{ position: 'absolute', right: '-8%', top: '10%', width: '52%', maxWidth: 700, opacity: 0.05, pointerEvents: 'none' }}>
        <img src="/assets/smt-logo-full.png" alt="" style={{ width: '100%', display: 'block' }} />
      </div>

      <div className="container" style={{ position: 'relative', zIndex: 2, paddingTop: 96, paddingBottom: 32 }}>
        {/* Big CTA line */}
        <div style={{ display: 'grid', gridTemplateColumns: '1.4fr 1fr', gap: 64, paddingBottom: 80, borderBottom: '1px solid rgba(255,255,255,0.1)', alignItems: 'end' }} className="footer-cta">
          <h2 className="display" style={{
            fontSize: 'clamp(40px, 7vw, 88px)', letterSpacing: '-0.03em', lineHeight: 1, color: '#fff', fontWeight: 600,
          }}>
            Building Nepal&rsquo;s next<br />
            <span style={{ color: '#9ED6AE' }}>thirty-six years</span>.
          </h2>
          <div>
            <p style={{ fontSize: 16, color: 'rgba(255,255,255,0.7)', lineHeight: 1.6, maxWidth: 380 }}>
              Whether you&rsquo;re building a home, planning a school renovation, or starting a multi-year programme &mdash; we&rsquo;d love to hear about it.
            </p>
            <Link to="/contact" style={{
              display: 'inline-flex', alignItems: 'center', gap: 10, marginTop: 24,
              padding: '12px 20px 12px 22px', background: 'var(--accent)', color: '#fff',
              textDecoration: 'none', borderRadius: 999, fontFamily: 'var(--text)', fontSize: 14, fontWeight: 500,
              border: '1px solid var(--accent)',
              transition: 'background .2s',
            }}>
              Start a conversation
              <span style={{
                display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                width: 24, height: 24, borderRadius: 5, background: '#fff', color: 'var(--accent)',
              }}><ArrowMark size={10} /></span>
            </Link>
          </div>
        </div>

        {/* Footer grid */}
        <div style={{ display: 'grid', gridTemplateColumns: '1.4fr 1fr 1fr 1.2fr', gap: 48, padding: '64px 0' }} className="footer-grid">
          <div>
            <div style={{ display: 'inline-block', padding: 12, background: '#fff', borderRadius: 14 }}>
              <Logo size={48} showWordmark={false} />
            </div>
            <p style={{ marginTop: 20, fontSize: 15, color: 'rgba(255,255,255,0.65)', lineHeight: 1.7, maxWidth: 320 }}>
              An engineering and construction firm headquartered at Tanka Prasad Marg, Baneshwor Height, Kathmandu. Building Nepal&rsquo;s homes, schools, hospitals, and institutional landmarks since 1989.
            </p>
            <div style={{ display: 'flex', gap: 10, marginTop: 24 }}>
              <a href="https://www.linkedin.com/company/smt-construction-pvt-ltd/" target="_blank" rel="noopener" aria-label="LinkedIn" style={{
                display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                width: 36, height: 36, borderRadius: 999, border: '1px solid rgba(255,255,255,0.18)', color: '#fff', textDecoration: 'none',
              }}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M19 0H5a5 5 0 00-5 5v14a5 5 0 005 5h14a5 5 0 005-5V5a5 5 0 00-5-5zM8 19H5V8h3v11zM6.5 6.7a1.75 1.75 0 11.01-3.5 1.75 1.75 0 010 3.5zM20 19h-3v-5.6c0-1.4-.5-2.4-1.8-2.4-1 0-1.6.7-1.9 1.4-.1.2-.1.6-.1.9V19h-3V8h3v1.3c.4-.6 1.1-1.5 2.7-1.5 2 0 3.5 1.3 3.5 4.1V19z"/></svg>
              </a>
              <a href="https://smtconstruction.com" target="_blank" rel="noopener" aria-label="Website" style={{
                display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                width: 36, height: 36, borderRadius: 999, border: '1px solid rgba(255,255,255,0.18)', color: '#fff', textDecoration: 'none',
              }}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>
              </a>
            </div>
          </div>

          <div>
            <div style={{ fontSize: 12, fontWeight: 600, color: 'rgba(255,255,255,0.5)', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: 20 }}>Navigation</div>
            <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: 10 }}>
              {navItems.map(n => (
                <li key={n.k}>
                  <Link to={n.path}
                    style={{ fontSize: 15, color: 'rgba(255,255,255,0.8)', textDecoration: 'none', transition: 'color .2s' }}
                    onMouseEnter={(e) => e.currentTarget.style.color = '#fff'}
                    onMouseLeave={(e) => e.currentTarget.style.color = 'rgba(255,255,255,0.8)'}>
                    {n.l}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div style={{ fontSize: 12, fontWeight: 600, color: 'rgba(255,255,255,0.5)', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: 20 }}>Services</div>
            <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: 10 }}>
              {['Civil work', 'Mechanical work', 'Electrical work', 'Sanitary work', 'Renovation & retrofit', 'Security upgrades'].map(s => (
                <li key={s}>
                  <Link to="/services"
                    style={{ fontSize: 15, color: 'rgba(255,255,255,0.8)', textDecoration: 'none' }}>
                    {s}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div style={{ fontSize: 12, fontWeight: 600, color: 'rgba(255,255,255,0.5)', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: 20 }}>Get in touch</div>
            <div style={{ fontSize: 15, color: 'rgba(255,255,255,0.85)', lineHeight: 1.7 }}>
              Tanka Prasad Marg<br />
              Baneshwor Height-10<br />
              Kathmandu, Nepal<br />
              <span style={{ color: 'rgba(255,255,255,0.5)' }}>P.O. Box 3563</span>
            </div>
            <div style={{ fontSize: 15, color: 'rgba(255,255,255,0.85)', lineHeight: 1.9, marginTop: 18 }}>
              <a href="tel:+97714599344" style={{ color: 'inherit', textDecoration: 'none', display: 'block' }}>+977 1 4599344</a>
              <a href="tel:+9779851144990" style={{ color: 'inherit', textDecoration: 'none', display: 'block' }}>+977 9851 144990</a>
              <a href="mailto:info@smtconstruction.com" style={{ color: 'var(--accent)', textDecoration: 'none', display: 'block', marginTop: 4 }}>info@smtconstruction.com</a>
            </div>
          </div>
        </div>

        {/* Credentials strip */}
        <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', padding: '24px 0', borderTop: '1px solid rgba(255,255,255,0.08)' }}>
          {[
            ['Class C', 'Licensed contractor'],
            ['ISO 9001:2015', 'Certified'],
            ['UNGM', 'Vendor 939303'],
            ['VAT', '500097003'],
            ['Est.', '1989 · 36 years'],
          ].map(([k, v]) => (
            <div key={k} style={{ display: 'inline-flex', alignItems: 'baseline', gap: 8, padding: '8px 14px', border: '1px solid rgba(255,255,255,0.12)', borderRadius: 999, fontSize: 12 }}>
              <span style={{ color: 'var(--accent)', fontWeight: 600 }}>{k}</span>
              <span style={{ color: 'rgba(255,255,255,0.55)' }}>{v}</span>
            </div>
          ))}
        </div>

        {/* Bottom row */}
        <div style={{ paddingTop: 24, paddingBottom: 8, borderTop: '1px solid rgba(255,255,255,0.08)', marginTop: 16 }}>
          <span style={{ fontSize: 12, color: 'rgba(255,255,255,0.4)' }}>
            © 2026 SMT Construction (P.) Ltd. All rights reserved.
          </span>
        </div>
      </div>
      <style>{`
        @media (max-width: 900px) {
          .footer-cta { grid-template-columns: 1fr !important; gap: 32px !important; padding-bottom: 48px !important; }
          .footer-grid { grid-template-columns: 1fr 1fr !important; gap: 32px !important; padding: 48px 0 !important; }
        }
        @media (max-width: 540px) { .footer-grid { grid-template-columns: 1fr !important; } }
      `}</style>
    </footer>
  );
}
